/**
 * Add an item to a localStorage() array
 * @param {String} name  The localStorage() key
 * @param {String} value The localStorage() value
 */
export function localstorageSession(name, value) {
  // Get the existing data
  // var existing = localStorage.getItem(name);

  // If no existing data, create an array
  // Otherwise, convert the localStorage string to an array
  // existing = existing ? existing.split(',') : [];
  // existing = existing ? JSON.stringify(existing) : [];

  // Add new data to localStorage Array
  // existing.push(value);

  // Save back to localStorage
  // localStorage.setItem(name, existing.toString());
  // localStorage.setItem(name, existing);
  if (localStorage.getItem(name) != null) {
    localStorage.setItem(name, JSON.stringify(value));
  }
}
